import React, {useState} from "react";
import {Col, Container, Nav, NavItem, NavLink, TabContent, TabPane} from "reactstrap";
import CardReportComponent from "./CardReportComponent";
import {
  BY,
  SHIPMENTS_BY_DAY,
  SHIPMENTS_BY_MONTH,
  SHIPMENTS_BY_WEEK,
  SHIPMENTS_BY_YEAR
} from "../../../Store/Shipments/Types";
import {getFirstDayOfCurrentMonth, getTodayWithTime} from "../../../Utils/Utils";

const ReportsComponent = () => {

  const getCurrentWeek = (hours: number, minutes: number, seconds: number) => {
    const d = new Date();
    const day = d.getDay();
    const diff = d.getDate() - day + (day === 0 ? -6 : 1);
    const week = new Date(d.setDate(diff));
    week.setHours(hours, minutes, seconds);
    return week;
  }
  //
  // const getMondayOfLastWeek = () => {
  //   const today = getCurrentWeek(0,0,0)
  //   return new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7, 0,0,0);
  // }
  //
  // const getLastDayOfLastWeek = () => {
  //   const monday = getMondayOfLastWeek();
  //   return new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + 6, 23,59,59);
  // }
  //
  // const getFirstDayOfLastMonth = () => {
  //   const date = getFirstDayOfCurrentMonth();
  //   date.setMonth(date.getMonth() - 1);
  //   date.setHours(0,0,0)
  //   return date;
  // }
  //
  // const getLastDayOfLastMonth = () => {
  //   const date = getFirstDayOfLastMonth();
  //   const day = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  //   day.setHours(23,59,59)
  //   return day;
  // }
  //
  const getFirstDayOfYear = () => {
    const date = new Date();
    const day = new Date(date.getFullYear(), 0, 1);
    day.setHours(0, 0, 0)
    return day;
  }
  //
  // const getFirstDayOfLastYear = () => {
  //   const date = getFirstDayOfYear();
  //   date.setFullYear(date.getFullYear() - 1)
  //   date.setHours(0,0,0)
  //   return date;
  // }
  //
  // const getLastDayOfLastYear = () => {
  //   const date = getFirstDayOfLastYear();
  //   date.setMonth(11, 31)
  //   date.setHours(23,59,59)
  //   return date;
  // }

  const [tab, setTab] = useState<BY>(SHIPMENTS_BY_DAY)

  const toggle = (tab: BY) => {
    setTab(tab)
  }

  return (
    <>
      <br/>
      <Container fluid={true}>
        <Col>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={tab === SHIPMENTS_BY_DAY ? "active" : ""}
                onClick={() => toggle(SHIPMENTS_BY_DAY)}
              >
                DIARIO
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={tab === SHIPMENTS_BY_WEEK ? "active" : ""}
                onClick={() => toggle(SHIPMENTS_BY_WEEK)}
              >
                SEMANAL
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={tab === SHIPMENTS_BY_MONTH ? "active" : ""}
                onClick={() => toggle(SHIPMENTS_BY_MONTH)}
              >
                MENSUAL
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={tab === SHIPMENTS_BY_YEAR ? "active" : ""}
                onClick={() => toggle(SHIPMENTS_BY_YEAR)}
              >
                ANUAL
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={tab}>
            <TabPane tabId={SHIPMENTS_BY_DAY}>
              <CardReportComponent
                start={getTodayWithTime(0, 0, 0)}
                end={getTodayWithTime(23, 59, 59)}
                by={SHIPMENTS_BY_DAY}
                currentTab={tab}
              />
            </TabPane>
            <TabPane tabId={SHIPMENTS_BY_WEEK}>
              <CardReportComponent
                start={getCurrentWeek(0, 0, 0)}
                end={getTodayWithTime(23, 59, 59)}
                by={SHIPMENTS_BY_WEEK}
                currentTab={tab}
              />
            </TabPane>
            <TabPane tabId={SHIPMENTS_BY_MONTH}>
              <CardReportComponent
                start={getFirstDayOfCurrentMonth()}
                end={getTodayWithTime(23, 59, 59)}
                by={SHIPMENTS_BY_MONTH}
                currentTab={tab}
              />
            </TabPane>
            <TabPane tabId={SHIPMENTS_BY_YEAR}>
              <CardReportComponent
                start={getFirstDayOfYear()}
                end={getTodayWithTime(23, 59, 59)}
                by={SHIPMENTS_BY_YEAR}
                currentTab={tab}
              />
            </TabPane>
          </TabContent>
        </Col>
      </Container>
    </>
  )
}

export default ReportsComponent
